/**
 * Video: the poster links to YouTube (works without JS); on click it is replaced by the youtube-nocookie player,
 * so nothing from YouTube loads before the visitor asks for the video.
 */
(() => {
  const init = (root) => {
    const play = root.querySelector('[data-video-play]');
    const id = root.dataset.videoId;
    if (!play || !/^[A-Za-z0-9_-]{11}$/.test(id || '')) {
      return;
    }
    play.setAttribute('role', 'button');

    const start = (event) => {
      event.preventDefault();
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      iframe.title = play.getAttribute('aria-label') || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      root.replaceChildren(iframe);
      iframe.focus();
    };

    play.addEventListener('click', start);
    play.addEventListener('keydown', (event) => {
      if (event.key === ' ') {
        start(event);
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-video-player]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
